import React from 'react';
import PropTypes from 'prop-types';
import { NakedButton, Flex, Text, Icon } from '@qga/roo-ui/components';
import { useDataLayer } from 'hooks/useDataLayer';
import { useDispatch, useSelector } from 'react-redux';
import { setRequestCallbackModalOpen } from 'store/property/propertyActions';
import { REQUEST_CALLBACK_PHONE_NUMBER } from 'config';
import styled from '@emotion/styled';
import { themeGet } from 'styled-system';
import { getExclusiveOffer } from 'store/exclusiveOffer/exclusiveOfferSelectors';

const ExclusiveContactDetails = ({ secondTabletSpot = false }) => {
  const dispatch = useDispatch();
  const exclusiveOffer = useSelector(getExclusiveOffer);

  const CallbackButton = styled(NakedButton)`
    border: none;
    width: auto;
    overflow: visible;
    font: inherit;
    line-height: normal;
    appearance: none;
    cursor: pointer;
    background: transparent;
    color: inherit;
  `;

  const CallbackLink = styled('a')`
    cursor: pointer;
    text-decoration: none;
    display: inline-block;
    color: ${themeGet('colors.ui.link')};
  `;

  const { emitInteractionEvent } = useDataLayer();

  const handleOnClick = () => {
    dispatch(setRequestCallbackModalOpen(true));
    emitInteractionEvent({
      type: `Request Callback Modal`,
      value: `Request Form Opened`,
      customAttributes: {
        user_event_value: `Exclusive Offer`,
      },
    });
  };

  return (
    <Flex
      flexDirection={exclusiveOffer ? ['row', 'row'] : ['column', 'row']}
      alignItems={['flex-start', 'center']}
      justifyContent={['flex-start', 'flex-start', 'space-between']}
      width={secondTabletSpot ? ['100%', '100%', '280px', '280px'] : ['100%', '280px', '280px', '280px']}
      mb={[4, 0, 0]}
      mt={[4, 4, 0]}
      pt={[0, 0, 10]}
      pl={[6, 0, 0]}
    >
      <CallbackButton onClick={handleOnClick} data-testid="request-callback-cta">
        <>
          <Icon name="phoneCallback" color="brand.primary" size={24} mr={2} />
          <Text fontSize="sm" color="greys.steel" fontWeight="bold" mr={secondTabletSpot ? [10, 110, 10] : [10, 5, 10]}>
            Request callback
          </Text>
        </>
      </CallbackButton>
      <CallbackLink
        href={`tel:${REQUEST_CALLBACK_PHONE_NUMBER}`}
        aria-label={`Contact Goulburn call center on ${REQUEST_CALLBACK_PHONE_NUMBER}`}
        data-testid="contact-call-center-cta"
        mt={[4, 0]}
        mr={[10, 0, 0]}
      >
        <Icon name="phone" color="brand.primary" size={24} mr={2} />
        <Text fontSize="sm" color="greys.steel" fontWeight="bold">
          {REQUEST_CALLBACK_PHONE_NUMBER}
        </Text>
      </CallbackLink>
    </Flex>
  );
};

ExclusiveContactDetails.propTypes = {
  secondTabletSpot: PropTypes.bool,
};

export default ExclusiveContactDetails;
